import React from 'react';
import * as PropTypes from 'prop-types';
import {convertIntoPerccentageValue} from './input-logic';
import {BasicNumberInput} from './basic-number-input';

export const PercentageInput = ({
	innerRef,
	value,
	maxLength,
	placeholder,
	disabled,
	hasError,
	onClick,
	onBlur,
	callback,
	showAsterisk,
	additionalPercentageSignInfo,
	width,
	modalView,
	alignLeft,
	cy,
	showDecimals,
	forceUpdate,
	zeroToHundred,
	noBorder,
	noLocked,
}) => {
	const specialRule = showDecimals && value ? value => parseFloat(value.toFixed(2)) : undefined;
	return (
		<BasicNumberInput
			innerRef={innerRef}
			placeholder={placeholder}
			value={value}
			hasError={hasError}
			onClick={onClick}
			onBlur={onBlur}
			disabled={disabled}
			converterValue={value =>
				convertIntoPerccentageValue(
					value,
					specialRule,
					showAsterisk,
					additionalPercentageSignInfo,
					zeroToHundred,
					maxLength
				)
			}
			callback={callback}
			showAsterisk={showAsterisk}
			width={width}
			modalView={modalView}
			alignLeft={alignLeft}
			cy={cy}
			specialRule={specialRule}
			forceUpdate={forceUpdate}
			noBorder={noBorder}
			noLocked={noLocked}
		></BasicNumberInput>
	);
};

PercentageInput.propTypes = {
	innerRef: PropTypes.any,
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blue the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	callback: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.any,
	/**
	 * Don't show border in invoice entry number fields
	 */
	noBorder: PropTypes.bool,
	/**
	 * Don't lock invoice entry number fields
	 */
	noLocked: PropTypes.bool,
	/**
	 * Add an asterisk (*) after the input value
	 */
	showAsterisk: PropTypes.bool,
	/**
	 * Additional information after % sign
	 */
	additionalPercentageSignInfo: PropTypes.string,

	/**
	 * Width of the input
	 */
	width: PropTypes.string,

	/**
	 * Specific styling for the scheduling modals
	 */
	modalView: PropTypes.bool,

	alignLeft: PropTypes.bool,
	cy: PropTypes.string,
	showDecimals: PropTypes.bool,
	/**
	 * Flag to force the input to re render
	 */
	forceUpdate: PropTypes.any,

	/**
	 * limite the values from 0% to 100%
	 *
	 * The input return an error if the values is out of thhe bounds
	 */
	zeroToHundred: PropTypes.bool,

	maxLength: PropTypes.number,
};

PercentageInput.defaultProps = {
	disabled: false,
	hasError: false,
};
